import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { Card } from '@insite-store360/shared';
@Component({
  selector: 'lib-mat-card',
  standalone: true,
  imports: [MatCardModule, MatIconModule, CommonModule],
  templateUrl: './mat-card.component.html',
  styleUrl: './mat-card.component.scss',
})
export class MatCardComponent implements OnInit {
  @Input() cardDetails: any;
  @Input() role: string = '';
  @Input() gridRow: string = 'grid-cols-1 xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-1';
  // @Input() imgURL!: string;
  filteredCardDetails: { title: string; count: number; logo?: string, iconName?: string }[] = [];
  public isdashboardpage: boolean = false;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.filterCardDetailsByRole();
    this.checkdashboardpage();
  }

  public checkdashboardpage() {
    this.isdashboardpage = this.router.url === '/dashboard/dashboard-page';
  }

  filterCardDetailsByRole() {
    switch (this.role) {
      case 'USER':
        // Display only selected cards for the 'USER' role
        this.filteredCardDetails = this.cardDetails.filter((card: Card) =>
          [
            'Total Promoter',
            'Total Stores',
            'Total Surveys',
            'Total Products',
          ].includes(card.title)
        );
        break;

      case 'country_pic':
        // Display only selected cards for the 'country_pic' role
        this.filteredCardDetails = this.cardDetails.filter((card: Card) =>
          [
            'Total Country PIC',
            'Total Regional Analyst',
            'Total Mobile Users',
            'Total Country',
            'Total Stores',
            'Total Surveys',
            'Total Products',
          ].includes(card.title)
        );
        break;
      case 'regional_head':
      case 'regional_analyst':
        // Display only selected cards for the 'regional_head/regional_analyst' role
        this.filteredCardDetails = this.cardDetails.filter((card: Card) =>
          [
            'Total Country PIC',
            'Total Regional Analyst',
            'Total Mobile Users',
            'Total Country',
            'Total Stores',
            'Total Surveys',
            'Total Products',
          ].includes(card.title)
        );
        break;
      default:
        // Display all cards for other roles
        this.filteredCardDetails = this.cardDetails;
        break;
    }
  }
}
